import { Component, Input, OnInit } from '@angular/core';

import { SiteStatVm } from 'app/shared/generated/Dashboard/Models/SiteStatVm';

@Component({
    selector: 'pcg-site-detail-card',
    templateUrl: './site-detail-card.component.html',
    styleUrls: ['./site-detail-card.component.scss'],
    standalone: false
})
export class SiteDetailCardComponent implements OnInit {

	@Input() model: SiteStatVm = new SiteStatVm();
	
	constructor() { }

	ngOnInit(): void { }
}
